import { useState } from 'react';
import { Button, InputGroup, Intent } from '@blueprintjs/core';
import { useDispatch } from 'react-redux';

import { updateRequestPriority } from '@f/services/batch-search/batch-search.actions';

import cls from './BatchSearchRequestPriority.module.css';

interface BatchSearchRequestPriorityProps {
  batch: {
    id: string;
    priority: number;
    status: {
      queued: number;
    };
    isRemoved: boolean;
  };
}
export function BatchSearchRequestPriority({ batch }: BatchSearchRequestPriorityProps) {
  const dispatch = useDispatch();
  const batchPriority = String(batch.priority);
  const isQueued = batch.status.queued > 0;
  const isRemoved = batch.isRemoved;
  const editable = isQueued && !isRemoved;

  const [priority, setPriority] = useState(batchPriority);
  const [saving, setSaving] = useState(false);

  const savePriority = async () => {
    setSaving(true);
    await dispatch(updateRequestPriority(batch.id, Number(priority)));
    setSaving(false);
  };

  return (
    <div className={cls.container} onClick={e => e.stopPropagation()}>
      <InputGroup
        type="number"
        min={1}
        max={10}
        value={priority}
        readOnly={!editable}
        leftIcon={editable ? 'cog' : undefined}
        style={{ width: '75px' }}
        onChange={event => {
          setPriority(event.target.value);
        }}
      />
      {editable && batchPriority !== priority && (
        <Button
          text="Change"
          onClick={() => {
            savePriority();
          }}
          loading={saving}
          intent={Intent.PRIMARY}
          fill
          className={cls.saveButton}
        />
      )}
    </div>
  );
}
